import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
// import MedicinePieChart from "./MedicinePieChart";
import { Breadcrumbs, P } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import SalesLineChart from "./SalesLineChart";
import NearlyExpiredProducts from "./NearlyExpiredProducts";
import ExpiredProducts from "./ExpiredProducts";
import TopPrescriptions from "./topRecentPrescriptions";
import MinAlertStock from "./MinAlertStock";
import { useLicense } from "../../_helper/license/LicenseContext";
import { formatExpiryTime, getExpiryRelativeTime } from "../../utils/licenseDataAndExpiry";
import { usePharmacy } from "../../_helper/PharmacyProvider";
import { isHospitalConnected as isPharmacyHospitalConnected } from "../../utils/pharmacyConnection";
const ClinicAdminDashboard = () => {

	const { pharmacyPOS } = usePharmacy();
	const isHospitalConnected = isPharmacyHospitalConnected(pharmacyPOS);

	return (
		<Fragment>
			<Breadcrumbs mainTitle="Dashboard" parent="Dashboard" title="Dashboard" />
			<Container fluid={true}>
				<Row className="align-items-stretch">
					<Col sm="12" lg="8" className="d-flex flex-column">
						<div className="flex-fill d-flex flex-column">
							<SalesLineChart />
						</div>
					</Col>
					<Col sm="12" lg="4" className="d-flex flex-column">
						<div className="flex-fill d-flex flex-column">
							<MinAlertStock />
						</div>
					</Col>
					<Col sm="12" md={isHospitalConnected ? '4' : '6'} className="d-flex flex-column">
						<div className="flex-fill d-flex flex-column">
							<NearlyExpiredProducts />
						</div>
					</Col>
					<Col sm="12" md={isHospitalConnected ? '4' : '6'} className="d-flex flex-column">
						<div className="flex-fill d-flex flex-column">
							<ExpiredProducts />
						</div>
					</Col>
					{isHospitalConnected && (
						<Col sm="12" lg="4" className="d-flex flex-column">
							<div className="flex-fill d-flex flex-column">
								<TopPrescriptions />
							</div>
						</Col>
					)}
				</Row>
			</Container>
		</Fragment>
	);
};

export default ClinicAdminDashboard;
